import * as yup from 'yup';
import 'yup-phone';

export const validationForm = yup.object().shape({
  firstName: yup.string().label('First Name').required(),
  lastName: yup.string().label('Last Name').required(),
  email: yup.string().label('Email').email().required(),
  phoneNumber: yup
    .string()
    .phone('Phone Number must be a valid phone number')
    .label('Phone Number')
    .required(),
});
